// Jornada estándar en Ecuador: 8 horas/día. Lo que exceda es hora extra.
export const JORNADA_ESTANDAR = 8;

// Horas trabajadas entre dos horarios "HH:MM". Si falta alguno, no se puede calcular (0).
// Si la salida es antes que la entrada, se asume que cruzó medianoche.
export function horasEntre(horaInicio, horaFin) {
  if (!horaInicio || !horaFin) return 0;
  const [h1, m1] = horaInicio.split(':').map(Number);
  const [h2, m2] = horaFin.split(':').map(Number);
  if ([h1, m1, h2, m2].some(Number.isNaN)) return 0;
  let mins = (h2 * 60 + m2) - (h1 * 60 + m1);
  if (mins < 0) mins += 24 * 60;
  return mins / 60;
}

export function horasExtraDe(horas) {
  return Math.max(0, horas - JORNADA_ESTANDAR);
}

export function fmtHoras(h) {
  if (!h) return '0h';
  const redondeado = Math.round(h * 100) / 100;
  return Number.isInteger(redondeado) ? `${redondeado}h` : `${redondeado.toFixed(2)}h`;
}

// Dado el array `dias` (JSON.parse de obra.diasTrabajo) y un personaId, suma horas
// trabajadas y horas extra a través de todos los días registrados.
export function totalesPorPersona(dias, personaId) {
  let horas = 0, extra = 0, diasTrabajados = 0;
  for (const dia of dias || []) {
    const asistente = (dia.asistentes || []).find(a => a.personaId === personaId);
    if (!asistente) continue;
    const h = horasEntre(asistente.horaInicio || dia.horaInicio, asistente.horaFin || dia.horaFin);
    if (h > 0) { horas += h; extra += horasExtraDe(h); diasTrabajados += 1; }
  }
  return { horas, extra, diasTrabajados };
}
